import { Spin } from 'antd';
import type { SpinSize } from 'antd/es/spin';
import type { SpinProps } from 'antd/lib/spin';
import type { FC } from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import styled from 'styled-components';

interface LoadingIndicatorProps extends SpinProps {
  text?: string;
  showText?: boolean;
  size?: SpinSize;
}

interface LoadingProps {
  text?: string;
  showText?: boolean;
  size?: SpinSize | 'xSmall' | 'xxSmall' | 'xxxSmall';
}

const StyledSpin = styled(props => <Spin {...props} />)`
  max-height: none !important;
  min-height: 100px;

  > div {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-left: -36px !important;
    margin-top: -36px !important;
  }
`;

const Loading: FC<LoadingProps> = ({ text, showText, size }) => {
  return (
    <div className="custom-spinner-wrapper">
      <div className={`custom-spinner-content ${size}`}>
        <div className="custom-spinner" />
        {showText && (
          <div className="custom-spinner-text">
            <FormattedHTMLMessage id={text} />
          </div>
        )}
      </div>
    </div>
  );
};

const LoadingIndicator: FC<LoadingIndicatorProps> = ({
  showText = false,
  text = 'Global.loading',
  size = 'default',
  ...spinProps
}) => {
  return (
    <StyledSpin
      {...spinProps}
      indicator={<Loading text={text} showText={showText} size={size} />}
    />
  );
};

if (Spin?.setDefaultIndicator) {
  Spin.setDefaultIndicator(<LoadingIndicator />);
}

export { LoadingIndicator };
